import { useEffect, useState } from "react";
import { Download, PlusSquare, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { canPrompt, isIOS, isStandalone, onPwaChange, promptInstall } from "@/lib/pwa";

// "Pasang App" button: native install prompt on Android/desktop Chrome, instructions on iPhone.
export default function InstallAppButton({ className = "" }) {
  const [, force] = useState(0);
  const [iosHelp, setIosHelp] = useState(false);
  useEffect(() => onPwaChange(() => force((n) => n + 1)), []);

  if (isStandalone()) return null;
  const ios = isIOS();
  if (!ios && !canPrompt()) return null;

  return (
    <>
      <Button
        variant="secondary"
        size="sm"
        className={`w-full justify-start ${className}`}
        onClick={() => (ios ? setIosHelp(true) : promptInstall())}
        data-testid="install-app-btn"
      >
        <Download className="mr-2 h-4 w-4" /> Pasang App di telefon
      </Button>
      <Dialog open={iosHelp} onOpenChange={setIosHelp}>
        <DialogContent className="border-border bg-card" data-testid="install-ios-dialog">
          <DialogHeader>
            <DialogTitle>Pasang PostPintar di iPhone</DialogTitle>
            <DialogDescription>Guna Safari, kemudian:</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-3"><Share className="h-5 w-5 shrink-0 text-primary" /> Tekan butang <b className="text-slate-200">Kongsi (Share)</b> di bawah skrin.</li>
            <li className="flex items-center gap-3"><PlusSquare className="h-5 w-5 shrink-0 text-primary" /> Pilih <b className="text-slate-200">Tambah ke Skrin Utama (Add to Home Screen)</b>.</li>
            <li className="flex items-center gap-3"><Download className="h-5 w-5 shrink-0 text-primary" /> Tekan <b className="text-slate-200">Tambah</b>. Ikon PostPintar akan muncul di skrin utama.</li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
}
